export const GENERATED_IDS = {
    "__MODIFIER_ID": {
        "MASTERS_CALL": "5a4f7a88-f089-4ba7-888f-412aa94f655a",
        "SEEDLING": "b6867bde-4ca2-4a8b-9c39-f431e42e0648"
    },
    "__SPELL_ID": {
        "DH": {
            "HAVOC": {
                "DARKNESS": "21771cdf-a784-4605-bcce-1e5d2ada834f"
            },
            "VENG": {
                "DARKNESS": "a4f552be-7f42-40a9-b7be-f5475119fc0f"
            }
        },
        "DK": {
            "BLOOD": {
                "AMZ": "6386b688-0165-484e-bd47-d2cdac170ada"
            },
            "FROST": {
                "AMZ": "9cb0595b-3b66-480b-862c-df40fb7cea1b"
            },
            "UNHOLY": {
                "AMZ": "feb876f1-8dcd-4a92-9234-577aece679e0"
            }
        },
        "DRUID": {
            "BALANCE": {
                "INNERVATE": "4c36b47f-9c7e-4d70-bab6-784e3054860f",
                "ROAR": "205c7568-79cf-4927-9539-bd8a2d64b4db",
                "VIGIL": "18af3624-ce9b-4ac4-8671-52648d197386"
            },
            "FERAL": {
                "INNERVATE": "5cc5e8a5-c07b-453c-87f6-75139b564e0f",
                "ROAR": "01f637f5-1404-4c9c-8a2a-297252707a82",
                "VIGIL": "514c1ffe-de1e-4329-9f7c-c32c3cec5f64"
            },
            "GUARDIAN": {
                "INNERVATE": "b897eab4-3a79-4d8d-a05a-8e5afca42681",
                "ROAR": "e4fefe2e-fba9-412a-af1b-1d2a30e5f2a9"
            },
            "RESTO": {
                "CONVOKE": "cc6474aa-1a23-4064-af59-8fd2fdde5587",
                "FLOURISH": "2b6b27a1-b184-440d-b33d-9378a7eaf6a3",
                "IRONBARK": "1163576b-e119-43fe-b17a-9021e0ebabb4",
                "ROAR": "6f969267-1c22-4585-9852-45fb2c6b3827",
                "TRANQ": "6795689c-037e-4568-957c-35e30eae6e35",
                "TREE": "833c2006-4530-441e-b9bb-8df2f71f5e92"
            }
        },
        "EVOKER": {
            "AUG": {
                "RESCUE": "032fe402-a58b-4433-ae30-d2715f8fb699",
                "SPAT_PARADOX": "931c6f1a-02b3-4d0b-88b1-519042430096",
                "SPIRAL": "f372b736-5827-4982-b657-ffcb0cef9deb",
                "ZEPHYR": "c454c95a-df24-46bb-b1ec-db5575a6466c"
            },
            "DEVA": {
                "RESCUE": "e848e549-ff36-461e-b171-9a86c6f43d61",
                "SPIRAL": "81c6a0e4-88ca-4d58-a078-378a58cd9872",
                "ZEPHYR": "a21c31fa-27af-430e-ad89-99e10a94b757"
            },
            "PRES": {
                "DREAM_FLIGHT": "45e29715-be0c-4ceb-a9f0-916db8c36ea5",
                "EM_COM": "0b334074-15b9-4f64-baa5-27442c2d152b",
                "RESCUE": "d49ffdc7-7c0b-4ca9-8af2-dda0cabdbf10",
                "REWIND": "2d020099-cda1-4cdd-96b1-4b61d5e53c62",
                "SPIRAL": "a2da2eeb-159f-4da1-832a-77bddb48c148",
                "TIME_DIALATION": "fc7719be-9707-4b79-be11-e1e6580d046e",
                "ZEPHYR": "430d3776-e86a-4f9e-bf53-0cc12ae0f114"
            }
        },
        "HUNTER": {
            "BM": {
                "MASTERS_CALL": "f2a3eb43-dad6-4f8e-8cd4-9e31e321ccb3",
                "TURTLE": "447abc6e-4f45-409b-a600-c37c486fa68f"
            },
            "MM": {
                "MASTERS_CALL": "3e3d7ca0-2d5f-4ac9-96b7-22749392a636",
                "TURTLE": "fb58730d-151a-48b8-8100-f47b51e91fe5"
            },
            "SV": {
                "MASTERS_CALL": "a3789fef-6a46-4667-ad95-bcaacbb4f292",
                "TURTLE": "e7767fd1-822f-4939-963d-44312f996a28"
            }
        },
        "MAGE": {
            "ARCANE": {
                "HPPOT": "955b8011-ce1b-49b8-bac4-f6a3cacda5df",
                "HS": "7b7dacff-a0e3-44f7-bc5f-6c0f9ac4421b",
                "MASS_BARRIER": "940785f5-e48d-42a7-b1a0-2bd29d3f99d0",
                "PERSONAL2MIN": "cb56d376-f42d-4100-b4ee-b7cb17c5beae"
            },
            "FIRE": {
                "MASS_BARRIER": "69505148-21ae-4115-91d7-b37b47d025f9"
            },
            "FROST": {
                "MASS_BARRIER": "c2aae075-4f7e-48d9-8146-f2dcd408b45e"
            }
        },
        "MONK": {
            "BRM": {
                "TIGERS_LUST": "7522cfd0-3958-443d-a286-7cb05d1212a0"
            },
            "MW": {
                "CHI_JI": "d74ce276-d46e-4094-b0f3-dc01c9c2aadd",
                "COCOON": "c2abca06-6a67-4266-b5f3-1c67a6455568",
                "REVIVAL": "bcb49fff-e6be-43a7-87f0-3924c80f69b1",
                "SEEDLING": "04677e77-160e-4492-bfd9-4688779d69e7",
                "SHE_GIFT": "b505633a-8976-49ca-b95b-7444b8eb1d98",
                "TIGERS_LUST": "d010caed-ec87-482b-87af-8cc59d03fab3",
                "YULON": "6a55e942-bebb-439e-9534-f7172dd9f3bd"
            },
            "WW": {
                "TIGERS_LUST": "60f9a873-e358-44ad-9946-8b9c8bd5beea"
            }
        },
        "PALADIN": {
            "HOLY": {
                "AM": "f4c9ddcb-69c4-4c2a-94f8-89581e08a4c0",
                "BLESS_SAC": "dfe0fd25-b7f7-4c16-b501-4fe23b95d5d3",
                "BOP": "86733566-6ab6-46ea-ab4a-bab3d2b1084a",
                "CRUSADER": "a6c48753-3e21-44a8-b671-f04f76391590",
                "DIVINE_TOLL": "41f8869e-36a9-4b89-8ea5-ceb2d3a5f5de",
                "DIV_SHIELD": "57c9cbbb-a53a-48ad-99d6-5470ac05dd6a",
                "FREEDOM": "c0314f42-8e26-4cf1-9ce4-dc1b3d5da1c0",
                "HOLY_AVENGER": "82ae822d-810a-4ea7-bf5f-37659b5c5732",
                "TYR_DELIVERANCE": "1bc7a0e4-44fa-4006-95ff-a90c900478cc",
                "WINGS": "a323b4eb-b7b8-4ecf-8927-9fe5b6c2bb85"
            },
            "PROT": {
                "BLESS_SAC": "223ebeb3-a3b1-4934-8088-c64e2333abac",
                "BOP": "ac2e2aab-5799-414d-9927-0dc90ccd63fb",
                "DIV_SHIELD": "7270f068-2855-493f-af9c-04f1470b8fdf",
                "FREEDOM": "b017d61c-8666-45ba-9334-25a84a08c05a",
                "SPELLWARDING": "c4b91863-0e64-415f-b7df-a61edb311063"
            },
            "RET": {
                "BLESS_SAC": "e205cd22-baf6-4791-9c5b-aa9cbd84b98f",
                "BOP": "30acd7aa-b771-45d5-b77b-0deebafaa17e",
                "DIV_SHIELD": "eeeff96c-29b3-4f74-98a7-4e3239da8e94",
                "FREEDOM": "73488826-37cf-477f-b6c5-930e06fc1f0b"
            }
        },
        "PRIEST": {
            "DISC": {
                "BARRIER": "6b801340-ee10-4763-a252-bf4d1265462a",
                "BENDER": "c1f89e9f-b82b-4260-b21b-4e883a47f904",
                "EVANG": "4365f48f-87f6-488f-aaf1-acabede5dfb8",
                "FIEND": "1b8f93b0-4912-4290-bd4c-1fbb76dcc570",
                "LEAP_OF_FAITH": "90e5941b-8b3c-4e6d-bb5b-cab423b22530",
                "MASS_DISPEL": "e5474b0b-d85d-4f21-8f59-a6d32db4ebe5",
                "PAINSUP": "cf7b5dd4-1b50-4b46-b22e-b3657d5b4dfb",
                "POWER_INFUSION": "e904a4d5-d48c-4bfc-bd04-32e503fb41b2",
                "RAPT": "dc628570-df9a-4120-a980-c322e7a12418",
                "ULTI_PEN": "bee1d61c-4ec8-40a7-9271-ade5e04c105d"
            },
            "HOLY": {
                "GUARDIAN_SPIRIT": "cdcb654f-712c-45b2-8297-74d2b9d793c5",
                "HYMN": "9c5fd215-e1e7-4428-b6d4-3921ee75b658",
                "LEAP_OF_FAITH": "2c5175b0-8d2f-4448-99a6-401bed1ff33a",
                "MASS_DISPEL": "1da6673b-364a-45a3-b8fb-b17bab4373ea",
                "POWER_INFUSION": "2411a7be-6253-4fed-aa14-8c5be8e4f9c8",
                "SALV": "46ff006b-94c9-4c8d-a874-ba4809bbf2d1",
                "SEEDLING": "c518e083-e2c4-40f3-b22c-13a392604b33",
                "SYMBOL_OF_HOPE": "e61379c8-5780-4df8-8a90-83079abcc1e2"
            },
            "SHADOW": {
                "EMBRACE": "29f0d1dc-b9c4-46e0-bf62-34f3cf90ff86",
                "LEAP_OF_FAITH": "77441883-c965-4adf-8ffb-7ec6d0460a1f",
                "MASS_DISPEL": "ebcc79a1-c952-4129-870d-7b810f00a2f6"
            }
        },
        "ROGUE": {
            "ASS": {},
            "OUT": {},
            "SUB": {}
        },
        "SHAMAN": {
            "ELE": {
                "ANCE_GUIDE": "22235b91-f2c7-4767-977c-14b81298a0fc",
                "WRT": "3b0c6694-b5c0-467c-88db-229019aa9714"
            },
            "ENH": {
                "ANCE_GUIDE": "50b8ca1b-360b-448a-9424-60fe77dedea5",
                "WRT": "ed6c4a47-d7ea-4b19-a25a-0d3f60f284ef"
            },
            "RESTO": {
                "ANCE_GUIDE": "9a7444f4-84f3-4ff6-8302-571d8814002b",
                "APT": "4b0a01d0-3880-49d9-bfaf-3d57b19ee9a4",
                "ASC": "8303fff4-933f-457d-9119-5a81c23f464b",
                "HTT": "6c76c167-7172-4356-9293-068a770aad3e",
                "MTT": "d38204ba-8251-4251-b1d9-0e4b0e16905d",
                "SLT": "3f3fbc8c-77b9-48fb-ae44-476557f52e60",
                "WRT": "3a923582-aebe-4734-9313-77623a02bccc"
            }
        },
        "WARLOCK": {
            "AFFLI": {},
            "DEMO": {},
            "DEST": {}
        },
        "WARRIOR": {
            "ARMS": {
                "RALLY": "b91e3291-cc03-4899-88a6-00303782d386"
            },
            "FURY": {
                "RALLY": "068b52d9-6405-4b9a-a974-c0fb84d8bb76"
            },
            "PROT": {
                "RALLY": "9c525ec0-db53-46ae-b854-c3b3f4a90b97"
            }
        }
    },
    "__TALENT_ID": {
        "DH": {
            "HAVOC": {
                "PITCH_BLACK": "5a32b827-1860-434c-915f-d470aac4b1c8"
            },
            "VENG": {
                "PITCH_BLACK": "d339058d-622c-4a33-a19e-86f712f8b9ab"
            }
        },
        "DK": {
            "BLOOD": {},
            "FROST": {},
            "UNHOLY": {}
        },
        "DRUID": {
            "BALANCE": {
                "IMPROVED_ROAR": "d1e6a9e3-a1ae-4ea1-b71e-c16d941a7750",
                "INNERVATE": "4f7afe94-0e36-41d8-8560-236fa522beb5",
                "VIGIL": "594a40e8-bd2f-4358-8e40-d9daa5580c58"
            },
            "FERAL": {
                "IMPROVED_ROAR": "d9c89245-c7cd-4c47-9453-0c3763b1e0f6",
                "INNERVATE": "a6970508-b6df-4db0-8d96-453da1bbaf70",
                "VIGIL": "cf4c2e81-6529-4ddc-8067-81ea5160ebbe"
            },
            "GUARDIAN": {
                "IMPROVED_ROAR": "894e4c1a-ba49-4a3b-b269-8b3744ea8993",
                "INNERVATE": "2bc3e4f6-11a9-4225-bc58-98697672c128"
            },
            "RESTO": {
                "CEN_GUIDANCE": "4b5a6ee9-25c2-437f-a1b1-00da51e60c56",
                "CONVOKE": "66b049ed-1881-40bb-8279-69b611e0ac77",
                "IMPROVED_ROAR": "abeb88c2-7c18-4580-8436-8cc6f0e45a12",
                "IMPR_IRONBARK": "d2f7d123-426d-4d97-a25a-d8f7cc661a09",
                "INNER_PEACE": "52016a77-9b0d-4b93-937f-18055955925a",
                "TREE": "498f753d-cfbc-4d2c-ba71-823753945c2e"
            }
        },
        "EVOKER": {
            "AUG": {
                "RESCUE": "aea41167-617a-4869-9209-57b95a9b7f96",
                "SPAT_PARADOX": "00de5e1c-3258-4141-8c08-4b3726c263b2",
                "SPIRAL": "7ced931c-d8d4-46bf-85cd-2bc713b2de65",
                "ZEPHYR": "cbe1ec7e-0b9b-43a8-b935-37ca95037a28"
            },
            "DEVA": {
                "RESCUE": "09f94147-cd2c-4760-b6a6-c72119ad16ff",
                "SPIRAL": "a797ceed-5721-49ab-89cb-cd5ef27c393c",
                "ZEPHYR": "4938f839-6a91-462c-b992-b41e78881fe9"
            },
            "PRES": {
                "DREAM_FLIGHT": "1982bd2c-d922-432a-842a-487e0232ec4a",
                "EM_COM": "eb1aebb0-bda2-40ae-9583-7880106bf32a",
                "ERASURE": "a4d2f672-c49e-4dfa-a83b-8bb53a8310b8",
                "RESCUE": "97cbd734-cbb8-44ce-92f3-f24f57f9c278",
                "SPIRAL": "c42ffd64-26da-4beb-b288-dbe82933f3e9",
                "TEMPORAL_ARTIFICER": "800d564e-c86d-4bee-ab87-5a946fd60f77",
                "ZEPHYR": "e4be4ca1-4cb2-4325-aeff-955cca81cec3"
            }
        },
        "HUNTER": {
            "BM": {
                "BORN_TO_BE_WILD_1_2": "28098ed2-33a2-4883-91e5-98e1ce3bed0d",
                "BORN_TO_BE_WILD_2_2": "044e86a9-885e-4180-a808-bb649682236d"
            },
            "MM": {
                "BORN_TO_BE_WILD_1_2": "e2e5a6fa-907e-4b17-bc51-164330309e88",
                "BORN_TO_BE_WILD_2_2": "40eddbc9-887e-4be7-a8b9-e270403823ba"
            },
            "SV": {
                "BORN_TO_BE_WILD_1_2": "aee09758-fd54-4baa-a99c-26e6bfc53275",
                "BORN_TO_BE_WILD_2_2": "4d6f3b2a-f84a-43f9-a018-8ec21fb84195"
            }
        },
        "MAGE": {
            "ARCANE": {
                "HPPOT": "cadc9039-5b5e-4f91-9abf-c76a7e631a73",
                "HS": "2a833adb-fb0e-4b54-9f98-af7a6cfc0e83",
                "MASS_BARRIER": "96558e37-14f0-443f-b8a1-14cb54899111",
                "PERSONAL2MIN": "abc55aba-b958-401e-9ea8-c46fcf6e7563"
            },
            "FIRE": {
                "MASS_BARRIER": "81b9786f-7c9a-4c30-b750-28f97721a7b7"
            },
            "FROST": {
                "MASS_BARRIER": "eb13e796-1375-43cd-b198-1f1f55d6baef"
            }
        },
        "MONK": {
            "BRM": {},
            "MW": {
                "CHI_JI": "3523dbe5-540b-41dd-b1cd-7d65ca1401ea",
                "CHRYS": "a7d8a267-6a18-4292-88a3-e013c519229e",
                "GIFT_OF_CELEST": "e8f11fe0-06b1-4369-9fed-f13344e8e213",
                "SHE_GIFT": "98617053-d678-46a5-aea8-6f8ad998a3d0",
                "TIGERS_LUST": "81601bb9-101e-454a-979e-a6ba776489ba"
            },
            "WW": {
                "TIGERS_LUST": "0eafdd9a-7464-4923-8f2f-0ee4b9ab9a46"
            }
        },
        "PALADIN": {
            "HOLY": {
                "BOP": "49cde047-4a88-4df9-80a1-4dc0c3953ac4",
                "CRUSADER": "aa2917be-60cb-40a9-8bb7-c2eda9cada45",
                "DIVINE_TOLL": "fd48549c-adae-4459-aa15-fa3d529f34df",
                "HOLY_AVENGER": "75ffa906-35ee-46fc-a1a3-846ee2e47899",
                "IMP_BLESSING": "c0b9d905-4faf-449e-8cc5-62d5af706e83",
                "QUICK_INVO": "9a5cd364-9619-40f6-b783-1d5135f4e7a3",
                "SAC_JUST": "7d749792-b86e-4a0c-b7af-a22c515c905d",
                "TYR_DELIVERANCE": "eabc5bf5-c27d-42d3-b6e0-8468e7c1a161",
                "UNBREAK_SPIRIT": "b88a8d95-329b-4a47-9001-6a40c7ce44d9",
                "UNWAVERING_SPIRIT": "b07d824b-dae9-4128-aa17-960113a669d6"
            },
            "PROT": {
                "BLESS_SAC": "3cc7d649-6033-4419-af00-b4c7451d08c9",
                "COUNSEL_1_2": "29bac947-b181-4ba8-9030-afb7044a0f31",
                "COUNSEL_2_2": "8e209307-a17b-46b0-910d-cc373e5f8ad5",
                "FREEDOM": "028b6cfa-7232-41e9-828d-7e59eb5e53b9",
                "IMP_BLESSING": "c98871c3-83ea-4293-890f-6e143e2a2e87",
                "SAC_JUST": "2f3db1c5-2619-41f2-84e1-c94a960532b8",
                "UNBREAK_SPIRIT": "ab2034fc-2930-4d09-b300-b18938ad2e1e"
            },
            "RET": {
                "BLESS_SAC": "7c6fd8c0-30bb-4bc6-9d50-2b969b7571b4",
                "IMP_BLESSING": "80586d92-41db-40f1-ae5f-a978012ca6fd",
                "SAC_JUST": "5c63e9af-48bd-4a08-8738-c71c1a540bcc",
                "UNBREAK_SPIRIT": "98dc455b-cea8-4003-a669-68bf94dbd706"
            }
        },
        "PRIEST": {
            "DISC": {
                "BENDER": "15632714-d0a2-4b64-91f8-0ebd519d44eb",
                "LEAP_OF_FAITH": "e5e78e16-a4aa-464d-88b2-e5579a580d85",
                "MASS_DISPEL": "fa4bff3c-7b54-41dc-affb-a8a66f7a7283",
                "MOVE_WITH_GRACE": "305ad67b-e950-4424-93fc-660b112f7b07",
                "POWER_INFUSION": "1c63e505-ed5c-45f8-97d4-634580f32502",
                "ULTI_PEN": "8f71aa7f-af2a-4dd2-9f1f-3d54359c0f46"
            },
            "HOLY": {
                "GUARDIAN_ANGEL": "db273c6f-f072-4542-9e40-ae7a5fc33544",
                "GUARDIAN_SPIRIT": "71c5868a-def8-466a-b63d-fc82da933afd",
                "LEAP_OF_FAITH": "01e447b9-c926-41c4-b00e-69b13791feb2",
                "MASS_DISPEL": "f5feefda-5464-4fa3-8970-51d652452328",
                "MOVE_WITH_GRACE": "44a0af8e-62d2-44b6-b9cf-b4ca047d62ca",
                "POWER_INFUSION": "4dfbac2d-6f87-4391-85b0-5080346a095e",
                "SALV": "a47c5164-18f6-4906-aeb5-e71f041811e7"
            },
            "SHADOW": {
                "LEAP_OF_FAITH": "360cde43-3b69-4401-8f26-68f5d56f4aeb",
                "MASS_DISPEL": "986f8c08-5f23-48e4-9af0-f9e974cccb01",
                "MOVE_WITH_GRACE": "7c3dbefe-6e19-495f-8e19-3913fd1bd2b7",
                "SANLAYN": "239021f7-5a79-419c-8da7-292588e70edd"
            }
        },
        "ROGUE": {
            "ASS": {},
            "OUT": {},
            "SUB": {}
        },
        "SHAMAN": {
            "ELE": {
                "ANCE_GUIDE": "b3b02b26-5e57-4717-9170-2b20da209a25",
                "WRT": "b5f1880d-fa01-4e01-abfa-90051be029d3"
            },
            "ENH": {
                "ANCE_GUIDE": "15d965d9-9925-4b64-ae46-a63d97c1f5ed",
                "WRT": "3b66a3e0-7960-40a3-9e5a-894951833520"
            },
            "RESTO": {
                "ANCE_GUIDE": "7b15b336-3209-4055-893d-8ef670236bca",
                "APT": "57ef3256-3b78-4c7e-bc3e-8767a590f7dd",
                "ASC": "407c87da-0b1a-4100-853d-7b7de8bc7387",
                "MTT": "b04b16b4-c8ac-411e-bbd2-c7e97a1fc66a",
                "WRT": "5d148a72-569a-4901-a4b1-6b5c05f71f17"
            }
        },
        "WARLOCK": {
            "AFFLI": {},
            "DEMO": {},
            "DEST": {}
        },
        "WARRIOR": {
            "ARMS": {},
            "FURY": {},
            "PROT": {}
        }
    }
}
